import { EditorGroupTitle } from "features/editor/sidebar/EditorGroup";
import { ReactNode } from "react";


export interface ControlLineProps {
    left: ReactNode;
    right: ReactNode;
}

export const ControlLine = (props: ControlLineProps) => {
    return <div className="flex items-center gap-3">
        <div className="flex-auto cursor-pointer">
            <EditorGroupTitle>
                {props.left}
            </EditorGroupTitle>
        </div>
        <div className="flex-none">
            {props.right}
        </div>
    </div>
}
